let buyStartTime = '';
export default {
  align: 'center',
  emptyBtn: false,
  submitText: '保存',
  column: [
    {
      label: '车场名称',
      type: 'tree',
      prop: 'spaceId',
      span: 8,
      search: true,
      cell: true,
      clearable: false,
      disabled: true,
      props: {
        label: 'title',
        value: 'key',
      },
      rules: [
        {
          message: '请选择车场名称',
          required: true,
        },
      ],
      dicUrl: '/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode?id=0',

    },
    {
      label: '车牌号',
      prop: 'carNo',
      type: 'tree',
      search: true,
      span: 8,
      dataType: 'string',
      dicData: [],
      props: {
        label: 'plateNumber',
        value: 'plateNumber',
      },
      rules: [
        {
          required: true,
          message: '请选择车牌号',
          trigger: 'change',
        },
      ],
    },
    {
      label: '区域',
      prop: 'regions',
      hide: true,
      span: 8,
      type: 'tree',
      multiple: true,
      checkStrictly: true,
      dataType: 'string',
      dicData: [],
      props: {
        label: 'title',
        value: 'id',
      },
      rules: [
        {
          required: true,
          message: '请选择通行区域',
          trigger: 'change',
        },
      ],
    },
    {
      label: '车辆类型',
      prop: 'carType',
      type: 'select',
      disabled: true,
      span: 8,
      dataType: 'number',
      dicUrl: 'api/blade-system/dict/dictionary?code=vehicle_type',
      props: { label: 'dictValue', value: 'dictKey' },
      rules: [
        {
          required: true,
          message: '请选择车型',
          trigger: 'change',
        },
      ],
    },
    {
      label: '收费套餐',
      prop: 'ruleId',
      type: 'tree',
      hide: true,
      editDisabled: true,
      dicData: [],
      span: 8,
      props: {
        label: 'remark',
        value: 'id',
      },
      rules: [
        {
          required: true,
          message: '请选择收费套餐',
          trigger: 'change',
        },
      ],

    },
    {
      label: '客户姓名',
      span: 8,
      prop: 'customerName',
      width: 70,
      maxlength: 10,
      showWordLimit: true,
      disabled: true,
      search: true,
      rules: [
        {
          required: true,
          message: '请输入客户姓名',
          trigger: 'blur',
        },
      ],
    },
    {
      label: '客户手机',
      prop: 'customerPhone',
      search: true,
      width: 100,
      span: 8,
      disabled: true,
      rules: [
        { pattern: /^[0-9]*[0-9][0-9]*$/, message: '手机号格式错误' },
        {
          trigger: 'blur',
          min: 11,
          max: 11,
          message: '请输入11位手机号码',
        },
        {
          required: true,
          message: '请输入手机号',
          trigger: 'blur',
        },
      ],
    },
    {
      label: '租赁起期',
      prop: 'buyStartTime',
      span: 8,
      width: 100,
      type: 'date',
      /* addDisplay: false,*/
      format: 'yyyy-MM-dd',
      valueFormat: 'yyyy-MM-dd 00:00:00',
      editDisabled: true,
      change(e){
        buyStartTime = e.value;
      },
      rules: [
        {
          required: true,
          message: '请输入租赁起期',
          trigger: 'change',
        },
      ],
    },
    {
      label: '续租时长',
      prop: 'cycleNum',
      span: 8,
      viewDisplay: false,
      hide: true,
      type: 'select',
      dicUrl: '/api/blade-system/dict/dictionary?code=car_month_package',
      props: {
        label: 'dictValue',
        value: 'dictKey',
      },
      dataType: 'number',
      rules: [
        {
          required: true,
          message: '请选择续租时长',
          trigger: 'change',
        },
      ],
    },
    {
      label: '租赁止期',
      prop: 'buyEndTime',
      type: 'date',
      width: 100,
      editDisabled: true,
      disabled: true,
      format: 'yyyy-MM-dd',
      valueFormat: 'yyyy-MM-dd 23:59:59',
      span: 8,
      /* disabled: true,*/
      /* addDisplay: false,*/
      rules: [
        {
          required: true,
          message: '请输入租赁止期',
          trigger: 'change',
        },
        {
          validator: (rule, value, callback) => {

            var dateStart = Date.parse(buyStartTime);
            var dateEnd = Date.parse(value);
            if (dateStart >= dateEnd) {
              callback(new Error('租赁止期必须大于租赁起期！'));
            } else {
              callback();
            }
          },
          trigger: 'change',
        },
      ],
    },
    {
      label: '应收金额',
      prop: 'shouldMoney',
      precision: 2,
      width: 70,
      disabled: true,
      hide: true,
      maxlength: 15,
      showWordLimit: true,
      mock: {
        type: 'number',
        max: 1,
        min: 2,
        precision: 2,
      },
      rules: [
        { pattern: /^\d+(\.\d+)?$/, message: '格式错误' },
      ],
      minRows: 0.01,
      span: 8,
    },
    {
      label: '车位编号',
      prop: 'lotNo',
      type: 'tree',
      search: true,
      showWordLimit: true,
      span: 8,
      dataType: 'string',
      dicData: [],
      props: {
        label: 'spaceCode',
        value: 'spaceCode',
      },
    },
    {
      label: '房间',
      prop: 'areaName',
      hide: true,
      span: 8,
      disabled: true,
    },
    {
      label: '备注',
      prop: 'remark1',
      hide: true,
      span: 24,
      type: 'textarea',
      minRows: 2,
      maxlength: 200,
      showWordLimit: true,
      overHidden: true,
      rules: [
        {
          required: false,
          message: '请输入备注1',
          trigger: 'change',
        },
      ],
    },
  ],
};

